<template>
  <div class="popup_in">
    <div class="popup pop-blocked">
      <div class="popup_close close-animate">
        <a href="javascript:void(0);" @click.prevent="$emit('close')"
          ><CloseSvg
        /></a>
      </div>
      <div class="title">
        האם אתה בטוח שברצונך למחוק את המסמך?
      </div>
      <div class="flex flex--center flex--content--center gap--5">
        <a class="bt_blue" @click.prevent="confirm">אישור</a>
        <a class="bt_blue" @click.prevent="$emit('close')">סגור</a>
      </div>
    </div>
  </div>
</template>

<script>
import CloseSvg from "../../assets/img/svg/close.svg";

export default {
  name: "ConfirmDelete",
  components: { CloseSvg },
  props: {
    onConfirm: {
      type: Function,
      required: true
    }
  },
  methods: {
    confirm() {
      this.onConfirm();
      this.$emit("close");
    }
  }
};
</script>
